import React from 'react'
import ContactIcon from './ContactIcon'

function Footer() {
  return (
    <div className='mx-[7%] lg:mx-[8%] mt-20 flex items-center justify-between mb-6'>
        <h2>Copyright © 2024. All rights are reserved</h2>
        <ContactIcon />
    </div>
  )
}

export default Footer